





















































import Vue from 'vue'
import drawer from './drawer.vue'
import { cloneDeep } from 'lodash'
import { columnsHistory } from './data'
import { IotAppServiceProxy } from '@/service-proxies/app-v2/iot-console.service-proxies'
const asp = new IotAppServiceProxy()

export default Vue.extend({
  props: ['app', 'gatewayCode'],
  components: { drawer },
  data() {
    return {
      dataList: [],
      timeShow: false,
      tableShow: true,
      visible: false,
      loading: false,
      pagination:{
        total: 0,
      current: 1,
      pageSize: 10,
      }
    }
  },
  computed: {
    columnsHistory() {
      return columnsHistory.map((item) => {
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    },
    drawerTitle() {
      if (this.app) {
        return this.app.name + this.$t('page_getwat_list_communication_history')
      } else {
        return ''
      }
    }
  },
  watch: {
   visible:{
     handler(){
       this.getmonitorLog()
     }
   }
  },
  created() {
   // this.getList()
   this.pagination.onChange = (currentPage) => {
      this.pagination.current = currentPage;
      this.getList();
    };
  },
  methods: {
    showDrawer() {
      this.visible = true
      this.getList()
    },
    onClose() {
      this.visible = false
    },
    showTable() {
      this.timeShow = false
      this.tableShow = true
    },
    showTime() {  
      this.tableShow = false
      this.timeShow = true
    },
    async getList() {
      this.dataList = []
      if (!this.app || !this.gatewayCode) {
        return
      }
      this.loading = true
      try {
        let params: any = {
          appCode: this.app.code,
          gatewayCode: this.gatewayCode,
          pageIndex: this.pagination.current,
          pageSize: this.pagination.pageSize
        }
        let res= await asp.pageIotAppCommunicationHistory(params)
        this.dataList = cloneDeep(res.items)
        this.pagination.total = res.totalCount
      } catch (e) {
        console.log(e)
      }
      this.loading = false
    },
    async getmonitorLog() {
      let params:any = {  
          appCode: this.app.code,
          enabled: this.visible,
          gatewayCode: this.gatewayCode
      }
      await asp.monitorLog(params)
    },
    copyText(row) {
    // console.log(row);  //每一行的数据
    let message = row.message;  //每一行的某个值，如选中的当前行的url
    var oInput = document.createElement('input');     //创建一个隐藏input（重要！）
    oInput.value = message;    //赋值
    // console.log(oInput.value);
    document.body.appendChild(oInput);
    oInput.select(); // 选择对象
    document.execCommand("Copy"); // 执行浏览器复制命令
    oInput.className = 'oInput';
    oInput.style.display='none';
    this.$message.success(this.$t('page_my_document_copysuccess'))
    },
    refresh() {
      this.pagination.current = 1
      this.getList()
    }
  }
})
